import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Download, Shield } from "lucide-react";
import { toast } from "@/hooks/use-toast";
import { EnrollmentTokenManager } from "@/components/EnrollmentTokenManager";

export default function InstallPage() {
  const downloadAgent = () => {
    const link = document.createElement('a');
    link.href = '/ServSpect-Agent-Setup.exe';
    link.download = 'ServSpect-Agent-Setup.exe';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    toast({
      title: "Download Started",
      description: "ServSpect Agent installer is downloading.",
    });
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Windows Agent Installation</h1>
        <p className="text-muted-foreground">
          Download and install monitoring components for your Windows systems
        </p>
      </div>

      {/* Enrollment Token Generator - This is what the script asks for */}
      <EnrollmentTokenManager />

      {/* Production Agent */}
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <div>
              <CardTitle className="flex items-center gap-2">
                <Download className="h-5 w-5" />
                ServSpect Agent for Windows
              </CardTitle>
              <CardDescription>
                Pre-built monitoring agent with easy GUI installer
              </CardDescription>
            </div>
            <Button onClick={downloadAgent} size="lg">
              <Download className="h-4 w-4 mr-2" />
              Download Agent
            </Button>
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid gap-4 md:grid-cols-3">
            <div className="space-y-2">
              <h4 className="font-medium text-sm">1. Download & Run</h4>
              <p className="text-sm text-muted-foreground">
                Download the setup file and run as administrator
              </p>
            </div>
            <div className="space-y-2">
              <h4 className="font-medium text-sm">2. Configure</h4>
              <p className="text-sm text-muted-foreground">
                Enter your tenant ID and configure monitoring settings
              </p>
            </div>
            <div className="space-y-2">
              <h4 className="font-medium text-sm">3. Monitor</h4>
              <p className="text-sm text-muted-foreground">
                Agent starts automatically and data appears in dashboard
              </p>
            </div>
          </div>

          <div className="bg-muted p-4 rounded-lg">
            <h4 className="font-medium mb-2">What the agent monitors:</h4>
            <div className="grid gap-2 md:grid-cols-2">
              <ul className="text-sm text-muted-foreground space-y-1">
                <li>• <strong>Core Performance:</strong> CPU, Memory, Disk, Network</li>
                <li>• <strong>Processes & Services:</strong> Top processes, Windows services</li>
                <li>• <strong>Hardware Health:</strong> Temperatures, SMART data, battery</li>
                <li>• <strong>OS Configuration:</strong> Updates, BitLocker, licenses</li>
              </ul>
              <ul className="text-sm text-muted-foreground space-y-1">
                <li>• <strong>Security Events:</strong> Logins, failures, PowerShell</li>
                <li>• <strong>Network Exposure:</strong> Open ports, RDP, WinRM</li>
                <li>• <strong>Asset Inventory:</strong> Hardware info, installed software</li>
                <li>• <strong>Real-time Monitoring:</strong> 15-30 second intervals</li>
              </ul>
            </div>
          </div>

          <Alert>
            <Shield className="h-4 w-4" />
            <AlertDescription>
              The agent sends data securely via HTTPS to your dashboard. 
              No external dependencies required.
            </AlertDescription>
          </Alert>
        </CardContent>
      </Card>
    </div>
  );
}